import PropTypes from 'prop-types'
import ActiveRecord from 'model/activeRecord'
import capitalize from 'lodash.capitalize'
import { isNil } from 'ramda'

class Person extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> Person constructor -', init)
    if (isNil(init)) return undefined
    this._first_name = init.first_name
    this._last_name = init.last_name
    this._full_name = init.full_name
    this._gender = init.gender
  }

  static shape = {
    ...ActiveRecord.shape,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    full_name: PropTypes.string,
    gender: PropTypes.string
  }

  get first_name() {
    return this._first_name ? capitalize(this._first_name) : ''
  }

  get last_name() {
    return this._last_name ? capitalize(this._last_name) : ''
  }

  get full_name() {
    return this._full_name
  }

  get gender() {
    return this._gender
  }

  // Calculable
  get getFullName() {
    return `${capitalize(this._first_name)} ${capitalize(this._last_name)}`
  }
}

export default Person
